<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    v-model="sidebarExpanded"
    width="220"
    >
    <v-app-bar color="white" class="hpo_color">
      <img v-bind:src="computeLogo" height="64px" alt="">
    </v-app-bar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand>
        <template v-for="(item, i) in menus">
          <template>
            <!--group with subitems-->
            <v-list-group v-if="item.items && !item.hideSub" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
                <v-list-item slot="activator" ripple="ripple">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <template v-for="(subItem, i) in item.items">
                  <!--sub group-->
                  <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                    <v-list-item slot="activator" ripple="ripple">
                      <v-list-item-content>
                        <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                      <v-list-item-content>
                        <v-list-item-title>{{ grand.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                  <!--child item-->
                  <v-list-item v-else :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                    <v-list-item-content>
                      <v-list-item-title><span>{{ subItem.title }}</span></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="subItem.action">
                      <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-item v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-item-action>
            </v-list-item>
        </template>
      </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import menu from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { getCurrentUserRoleId, hasFeatureAccess, hasLegacyRoleAccess } from '@/commons/utils';
export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    mini: false,
    rawMenus: menu,
    scrollSettings: {
      maxScrollbarLength: 160,
      wheelPropagation: true
    }    
  }),
  computed: {
    menus() {
      return this.filterMenuItems(this.rawMenus);
    },
    sidebarExpanded: {
      get() {
        return this.$store.state.commons.sidebarExpanded;
      },
      set(val) {
        this.$store.commit("commons/setSidebarExpanded", { expanded: val });
      }
    },
    computeGroupActive () {
      return true;
    },
    computeLogo () {
      return process.env.NODE_ENV === "production" ? '/static/logo.png' : '';
    },
    userRoleId() {
      return getCurrentUserRoleId(this.$store);
    },
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    }
  },
  created() {
    this.fetchData();
    this.timer = setInterval(this.fetchData, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    fetchData() {
      if(document.hidden) {
        return;
      }
      if(localStorage.getItem('jwt') == null) {
        setTimeout(this.$router.replace({ path: '/login' }),100);
      }
    },
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${(subItem.name)}` };
    },
    filterMenuItems(items = []) {
      return items.reduce((acc, entry) => {
        const clone = { ...entry };
        
        // Recursively filter child items
        if (entry.items) {
          clone.items = this.filterMenuItems(entry.items);
        }
        
        // Filter children based on permission
        if (entry.children) {
          clone.children = entry.children.filter(child => {
            const childPermKey = child.permissionKey || entry.permissionKey;
            return this.hasFeatureAccess(childPermKey);
          });
        }
        
        // Check if this item should be displayed
        const isVisible = this.shouldDisplayItem(clone);
        
        // If item has sub-items/children, only show parent if at least one child is visible
        const hasVisibleChildren = (clone.items && clone.items.length > 0) || (clone.children && clone.children.length > 0);
        
        // Show item if: it's visible AND (it's not a parent OR it has visible children)
        if (isVisible && (!entry.items && !entry.children || hasVisibleChildren)) {
          acc.push(clone);
        } else if (hasVisibleChildren && !isVisible) {
          // Even if parent is not visible, show it if it has visible children (for group menus)
          acc.push(clone);
        }
        
        return acc;
      }, []);
    },
    shouldDisplayItem(item) {
      if (item.permissionKey) {
        return this.hasFeatureAccess(item.permissionKey);
      }
      return hasLegacyRoleAccess(this.userRoleId, item.roleId);
    },
    hasFeatureAccess(featureKey, minimum = 1) {
      return hasFeatureAccess(this.$store, featureKey, minimum);
    },
  }
};
</script>


<style lang="stylus">
#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

</style>
